var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--icon-color)",
    height: "800px",
    width: "800px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,19h-4.5c-0.3,0-0.5-0.1-0.7-0.3L16,10.5l-7.8,8.2C8,18.9,7.8,19,7.5,19H3c-0.4,0-0.8-0.2-0.9-0.6 C1.9,18,2,17.6,2.3,17.3l13-14c0.4-0.4,1.1-0.4,1.5,0l13,14c0.3,0.3,0.3,0.7,0.2,1.1C29.8,18.8,29.4,19,29,19z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,21c-0.8,0-1.6-0.3-2.2-0.9L16,13.4l-6.3,6.7C9.1,20.7,8.3,21,7.5,21H6v7c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1v-7H24.5z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.e68c8b1d70e6423af6f8e54c2c23cce7.svg";
export { ForwardRef as ReactComponent };